import apiWorker from '../apiWorker'

const questionnaire =  {
    submit : (data) => apiWorker('post', `/v1/api/questionnaire/submit`, data),
}

export default questionnaire;